import React from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import LoginForm from "../components/login/LoginForm";
import "../styles/login.css";

export default function LandingPage() {
  return (
    <section className="landing-page">
      <Navbar />

      <div className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">AI Powered Lead Management</div>

            <h1 className="hero-headline">
              Capture Property Leads Automatically
            </h1>

            <p className="hero-subtext">
              Prodicus helps real estate agents capture, manage, and convert
              property leads using an intelligent dashboard.
            </p>

            <ul className="hero-features">
              <li>AI Chat Lead Capture</li>
              <li>Smart Lead Dashboard</li>
              <li>Agent Lead Management</li>
            </ul>
          </div>

          <div className="hero-form">
            <LoginForm role="agent" title="Agent Login" subtext="" />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}
